import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      margin: 0,
      overflow: 'hidden',

      // for 13" macbook
      '@media screen and (max-height: 800px)': {
        maxHeight: 'calc(100% - 20px)',
      },
    },
    hideActions: {},
    hasDialogActionsSlot: {},

    dialogTitle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '&$noTitle': {
        padding: 0,
        '& $buttonClose': {
          top: theme.spacing(2),
        },
      },
    },
    title: {
      flex: 1,
      color: COLORS.gray.black,
    },
    buttonBack: {
      color: COLORS.gray.black,
    },
    buttonClose: {
      position: 'absolute',
      top: theme.spacing(2.5),
      right: theme.spacing(2),
    },
    noTitle: {},
    scrollable: {
      overflowY: 'auto',
      height: 'calc(100% - 73px)', // 73px is the height of buttons part of the popup

      '$hideActions &': {
        height: '100%',
      },
    },
    dialogActions: {
      '$hasDialogActionsSlot &': {
        justifyContent: 'space-between',
      },
    },
    dialogActionsSlot: {},
    actions: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
    },
    buttonCancel: {
      minWidth: 80,
    },
    buttonSubmit: {
      minWidth: 80,
    },
  }),
  { name: 'CustomDialog' }
);
